import { Container } from "inversify";
import { SERVICE_TYPES } from "./ServiceTypes";
import "reflect-metadata";
import {
  CPLAuthAuthenticationClient,
  CPLAuthClientPortalCookiesClient,
  CPLAuthClientPortalUsersClient,
  CPLAuthCompaniesClient,
  CPLAuthCompanyBrandingClient,
  CPLAuthImpersonationClient,
  CPLAuthMaintenanceClient,
  ICPLAuthAuthenticationClient,
  ICPLAuthClientPortalCookiesClient,
  ICPLAuthClientPortalUsersClient,
  ICPLAuthCompaniesClient,
  ICPLAuthCompanyBrandingClient,
  ICPLAuthImpersonationClient,
  ICPLAuthMaintenanceClient,
} from "services/api/cplauthapi/CPLAuthAPI";
import { CompaniesService, ICompaniesService } from "services/CompaniesService";
import { ISessionService, SessionService } from "services/SessionService";
import { AuthenticationService, IAuthenticationService } from "services/AuthenticationService";
import { ClientPortalUsersService, IClientPortalUsersService } from "services/ClientPortalUsersService";
import {
  CPLClientPortalAccountContactDetailsClient,
  CPLClientPortalAccountsClient,
  CPLClientPortalBudgetsClient,
  CPLClientPortalCaseTypesClient,
  CPLClientPortalCasesClient,
  CPLClientPortalClientsClient,
  CPLClientPortalCommentsClient,
  CPLClientPortalCreditControlClient,
  CPLClientPortalDevelopmentsClient,
  CPLClientPortalDocumentsClient,
  CPLClientPortalGlobalSearchClient,
  CPLClientPortalJobsClient,
  CPLClientPortalMeetingTypesClient,
  CPLClientPortalMeetingsClient,
  CPLClientPortalNewsClient,
  CPLClientPortalPaymentsClient,
  CPLClientPortalPropertiesClient,
  CPLClientPortalProposedWorkTypesClient,
  CPLClientPortalProposedWorksClient,
  CPLClientPortalSettingsClient,
  CPLClientPortalWebNarrativesClient,
  CPLSettingsClient,
  CPLTextEditorImageUploadClient,
  ICPLClientPortalAccountContactDetailsClient,
  ICPLClientPortalAccountsClient,
  ICPLClientPortalBudgetsClient,
  ICPLClientPortalCaseTypesClient,
  ICPLClientPortalCasesClient,
  ICPLClientPortalClientsClient,
  ICPLClientPortalCommentsClient,
  ICPLClientPortalCreditControlClient,
  ICPLClientPortalDevelopmentsClient,
  ICPLClientPortalDocumentsClient,
  ICPLClientPortalGlobalSearchClient,
  ICPLClientPortalJobsClient,
  ICPLClientPortalMeetingTypesClient,
  ICPLClientPortalMeetingsClient,
  ICPLClientPortalNewsClient,
  ICPLClientPortalPaymentsClient,
  ICPLClientPortalPropertiesClient,
  ICPLClientPortalProposedWorkTypesClient,
  ICPLClientPortalProposedWorksClient,
  ICPLClientPortalSettingsClient,
  ICPLClientPortalWebNarrativesClient,
  ICPLSettingsClient,
  ICPLTextEditorImageUploadClient,
} from "services/api/cplapi/CPLAPI";
import { ISettingsService, SettingsService } from "services/SettingsService";
import { ClientsService, IClientsService } from "services/ClientsService";
import { ClientPortalAccountsService, IClientPortalAccountsService } from "services/ClientPortalAccountsService";
import { CompanyBrandingService, ICompanyBrandingService } from "services/CompanyBrandingService";
import { ClientPortalJobsService, IClientPortalJobsService } from "services/ClientPortalJobsService";
import { ClientPortalCommentsService, IClientPortalCommentsService } from "services/ClientPortalCommentsService";
import { ITextEditorImageUploadService, TextEditorImageUploadService } from "services/TextEditorImageUploadService";
import { ClientPortalCasesService, IClientPortalCasesService } from "services/ClientPortalCasesService";
import { ClientPortalPropertiesService, IClientPortalPropertiesService } from "services/ClientPortalPropertiesService";
import { ClientPortalCaseTypesService, IClientPortalCaseTypesService } from "services/ClientPortalCaseTypesService";
import {
  ClientPortalProposedWorksService,
  IClientPortalProposedWorksService,
} from "services/ClientPortalProposedWorksService";
import { ClientPortalDocumentsService, IClientPortalDocumentsService } from "services/ClientPortalDocumentsService";
import {
  ClientPortalCreditControlService,
  IClientPortalCreditControlService,
} from "services/ClientPortalCreditControlService";
import { ClientPortalMeetingsService, IClientPortalMeetingsService } from "services/ClientPortalMeetingsService";
import {
  ClientPortalMeetingTypesService,
  IClientPortalMeetingTypesService,
} from "services/ClientPortalMeetingTypesService";
import {
  ClientPortalProposedWorkTypesService,
  IClientPortalProposedWorkTypesService,
} from "services/ClientPortalProposedWorkTypesService";
import {
  ClientPortalGlobalSearchService,
  IClientPortalGlobalSearchService,
} from "services/ClientPortalGlobalSearchService";
import { ClientPortalNewsService, IClientPortalNewsService } from "services/ClientPortalNewsService";
import { ClientPortalPaymentsService, IClientPortalPaymentsService } from "services/ClientPortalPaymentsService";
import {
  ClientPortalAccountContactDetailsService,
  IClientPortalAccountContactDetailsService,
} from "services/ClientPortalAccountContactDetailsService";
import {
  ClientPortalDevelopmentsService,
  IClientPortalDevelopmentsService,
} from "services/ClientPortalDevelopmentsService";
import { IMaintenanceService, MaintenanceService } from "services/MaintenanceService";
import {
  ClientPortalWebNarrativesService,
  IClientPortalWebNarrativesService,
} from "services/ClientPortalWebNarrativesService";
import {
  ClientPortalCPLSettingsService,
  IClientPortalCPLSettingsService,
} from "services/ClientPortalCPLSettingsService";
import { ClientPortalCookieService, IClientPortalCookieService } from "services/ClientPortalCookieService";
import { ClientPortalBudgetsService, IClientPortalBudgetsService } from "services/ClientPortalBudgetsService";

const container = new Container();

// cpl auth api clients
container.bind<ICPLAuthAuthenticationClient>(SERVICE_TYPES.CPLAuthAuthenticationClient).to(CPLAuthAuthenticationClient);
container.bind<ICPLAuthImpersonationClient>(SERVICE_TYPES.CPLAuthImpersonationClient).to(CPLAuthImpersonationClient);
container.bind<ICPLAuthCompaniesClient>(SERVICE_TYPES.CPLAuthCompaniesClient).to(CPLAuthCompaniesClient);
container
  .bind<ICPLAuthClientPortalUsersClient>(SERVICE_TYPES.CPLAuthClientPortalUsersClient)
  .to(CPLAuthClientPortalUsersClient);
container.bind<ICPLSettingsClient>(SERVICE_TYPES.CPLSettingsClient).to(CPLSettingsClient);
container
  .bind<ICPLAuthCompanyBrandingClient>(SERVICE_TYPES.CPLAuthCompanyBrandingClient)
  .to(CPLAuthCompanyBrandingClient);
container.bind<ICPLAuthMaintenanceClient>(SERVICE_TYPES.CPLAuthMaintenanceClient).to(CPLAuthMaintenanceClient);
container
  .bind<ICPLAuthClientPortalCookiesClient>(SERVICE_TYPES.CPLAuthClientPortalCookiesClient)
  .to(CPLAuthClientPortalCookiesClient);

// cpl api clients
//container.bind<ICPLDevelopmentsClient>(SERVICE_TYPES.CPLDevelopmentsClient).to(CPLDevelopmentsClient)
container
  .bind<ICPLClientPortalClientsClient>(SERVICE_TYPES.CPLClientPortalClientsClient)
  .to(CPLClientPortalClientsClient);
container
  .bind<ICPLClientPortalAccountsClient>(SERVICE_TYPES.CPLClientPortalAccountsClient)
  .to(CPLClientPortalAccountsClient);
container.bind<ICPLClientPortalJobsClient>(SERVICE_TYPES.CPLClientPortalJobsClient).to(CPLClientPortalJobsClient);
container
  .bind<ICPLClientPortalCommentsClient>(SERVICE_TYPES.CPLClientPortalCommentsClient)
  .to(CPLClientPortalCommentsClient);
container
  .bind<ICPLTextEditorImageUploadClient>(SERVICE_TYPES.CPLTextEditorImageUploadClient)
  .to(CPLTextEditorImageUploadClient);
container.bind<ICPLClientPortalCasesClient>(SERVICE_TYPES.CPLClientPortalCasesClient).to(CPLClientPortalCasesClient);
container
  .bind<ICPLClientPortalPropertiesClient>(SERVICE_TYPES.CPLClientPortalPropertiesClient)
  .to(CPLClientPortalPropertiesClient);
container
  .bind<ICPLClientPortalCaseTypesClient>(SERVICE_TYPES.CPLClientPortalCaseTypesClient)
  .to(CPLClientPortalCaseTypesClient);
container
  .bind<ICPLClientPortalProposedWorksClient>(SERVICE_TYPES.CPLClientPortalProposedWorksClient)
  .to(CPLClientPortalProposedWorksClient);
container
  .bind<ICPLClientPortalDocumentsClient>(SERVICE_TYPES.CPLClientPortalDocumentsClient)
  .to(CPLClientPortalDocumentsClient);
container
  .bind<ICPLClientPortalCreditControlClient>(SERVICE_TYPES.CPLClientPortalCreditControlClient)
  .to(CPLClientPortalCreditControlClient);
container
  .bind<ICPLClientPortalMeetingsClient>(SERVICE_TYPES.CPLClientPortalMeetingsClient)
  .to(CPLClientPortalMeetingsClient);
container
  .bind<ICPLClientPortalMeetingTypesClient>(SERVICE_TYPES.CPLClientPortalMeetingTypesClient)
  .to(CPLClientPortalMeetingTypesClient);
container
  .bind<ICPLClientPortalProposedWorkTypesClient>(SERVICE_TYPES.CPLClientPortalProposedWorkTypesClient)
  .to(CPLClientPortalProposedWorkTypesClient);
container
  .bind<ICPLClientPortalGlobalSearchClient>(SERVICE_TYPES.CPLClientPortalGlobalSearchClient)
  .to(CPLClientPortalGlobalSearchClient);
container.bind<ICPLClientPortalNewsClient>(SERVICE_TYPES.CPLClientPortalNewsClient).to(CPLClientPortalNewsClient);
container
  .bind<ICPLClientPortalPaymentsClient>(SERVICE_TYPES.CPLCLientPortalPaymentsClient)
  .to(CPLClientPortalPaymentsClient);
container
  .bind<ICPLClientPortalDevelopmentsClient>(SERVICE_TYPES.CPLClientPortalDevelopmentsClient)
  .to(CPLClientPortalDevelopmentsClient);
container
  .bind<ICPLClientPortalAccountContactDetailsClient>(SERVICE_TYPES.CPLClientPortalAccountContactDetailsClient)
  .to(CPLClientPortalAccountContactDetailsClient);
container
  .bind<ICPLClientPortalWebNarrativesClient>(SERVICE_TYPES.CPLClientPortalWebNarrativesClient)
  .to(CPLClientPortalWebNarrativesClient);
container
  .bind<ICPLClientPortalSettingsClient>(SERVICE_TYPES.CPLClientPortalSettingsClient)
  .to(CPLClientPortalSettingsClient);
container
  .bind<ICPLClientPortalBudgetsClient>(SERVICE_TYPES.CPLClientPortalBudgetsClient)
  .to(CPLClientPortalBudgetsClient);

// services
container.bind<ICompaniesService>(SERVICE_TYPES.CompaniesService).to(CompaniesService);
container.bind<ISessionService>(SERVICE_TYPES.SessionService).to(SessionService);
container.bind<IAuthenticationService>(SERVICE_TYPES.AuthenticationService).to(AuthenticationService);
container.bind<IClientPortalUsersService>(SERVICE_TYPES.ClientPortalUsersService).to(ClientPortalUsersService);
container.bind<IClientPortalAccountsService>(SERVICE_TYPES.ClientPortalAccountsService).to(ClientPortalAccountsService);
container.bind<ISettingsService>(SERVICE_TYPES.SettingsService).to(SettingsService);
container.bind<ICompanyBrandingService>(SERVICE_TYPES.CompanyBrandingService).to(CompanyBrandingService);
container.bind<IClientsService>(SERVICE_TYPES.ClientsService).to(ClientsService);
container.bind<IClientPortalJobsService>(SERVICE_TYPES.ClientPortalJobsService).to(ClientPortalJobsService);
container.bind<IClientPortalCommentsService>(SERVICE_TYPES.ClientPortalCommentsService).to(ClientPortalCommentsService);
container
  .bind<ITextEditorImageUploadService>(SERVICE_TYPES.TextEditorImageUploadService)
  .to(TextEditorImageUploadService);
container.bind<IClientPortalCasesService>(SERVICE_TYPES.ClientPortalCasesService).to(ClientPortalCasesService);
container
  .bind<IClientPortalPropertiesService>(SERVICE_TYPES.ClientPortalPropertiesService)
  .to(ClientPortalPropertiesService);
container
  .bind<IClientPortalCaseTypesService>(SERVICE_TYPES.ClientPortalCaseTypesService)
  .to(ClientPortalCaseTypesService);
container
  .bind<IClientPortalProposedWorksService>(SERVICE_TYPES.ClientPortalProposedWorksService)
  .to(ClientPortalProposedWorksService);
container
  .bind<IClientPortalDocumentsService>(SERVICE_TYPES.ClientPortalDocumentsService)
  .to(ClientPortalDocumentsService);
container
  .bind<IClientPortalCreditControlService>(SERVICE_TYPES.CPLClientPortalCreditControlService)
  .to(ClientPortalCreditControlService);
container
  .bind<IClientPortalMeetingsService>(SERVICE_TYPES.CPLClientPortalMeetingsService)
  .to(ClientPortalMeetingsService);
container
  .bind<IClientPortalMeetingTypesService>(SERVICE_TYPES.CPLClientPortalMeetingTypesService)
  .to(ClientPortalMeetingTypesService);
container
  .bind<IClientPortalProposedWorkTypesService>(SERVICE_TYPES.CPLClientPortalProposedWorkTypesService)
  .to(ClientPortalProposedWorkTypesService);
container
  .bind<IClientPortalGlobalSearchService>(SERVICE_TYPES.ClientPortalGlobalSearchService)
  .to(ClientPortalGlobalSearchService);
container.bind<IClientPortalNewsService>(SERVICE_TYPES.CPLClientPortalNewsService).to(ClientPortalNewsService);
container.bind<IClientPortalPaymentsService>(SERVICE_TYPES.ClientPortalPaymentsService).to(ClientPortalPaymentsService);
container
  .bind<IClientPortalAccountContactDetailsService>(SERVICE_TYPES.ClientPortalAccountContactDetailsService)
  .to(ClientPortalAccountContactDetailsService);
container
  .bind<IClientPortalDevelopmentsService>(SERVICE_TYPES.ClientPortalDevelopmentsService)
  .to(ClientPortalDevelopmentsService);
container.bind<IMaintenanceService>(SERVICE_TYPES.MaintenanceService).to(MaintenanceService);
container
  .bind<IClientPortalWebNarrativesService>(SERVICE_TYPES.ClientPortalWebNarrativesService)
  .to(ClientPortalWebNarrativesService);
container
  .bind<IClientPortalCPLSettingsService>(SERVICE_TYPES.ClientPortalCPLSettingsService)
  .to(ClientPortalCPLSettingsService);
container.bind<IClientPortalCookieService>(SERVICE_TYPES.ClientPortalCookieService).to(ClientPortalCookieService);
container.bind<IClientPortalBudgetsService>(SERVICE_TYPES.ClientPortalBudgetsService).to(ClientPortalBudgetsService);

export { container };
